import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'

import Layout from '../components/Layout'
import Container from '../components/Container'
import Card from '../components/Card'
import Link from '../components/Link'

import './Services.scss'

const imageSizes = '(min-width: 1024px) 150px, (min-width: 768px) 113px, 240px'

const ServiceImage = ({ image, alt }) =>
  <Img className='Services--container--card--image' fluid={{ ...image.childImageSharp.fluid, sizes: imageSizes }} alt={alt} />

const Services = ({ location, data }) =>
  <Layout
    location={location}
    title='Pawsome Dogs | Chicago Dog Training | Services'
    description='Pawsome Dogs provides dog and puppy training in Chicago. Professional in home dog trainers, specializing in obedience and behavior training.'>
    <main className='Services'>

      <Container className='Services--container'>

        <h2>In Home Private Lessons</h2>
        <p>All Chicago dog training private lessons are done either in your home or
          neighborhood. Lessons are customized to work on what you want to focus
          on. Perfect for someone with a busy schedule, a new puppy, behavioral issue,
          or wants training with real world distractions. Each lesson is one hour.</p>

        <p className="Services--container--completed">
          To ensure the best training for your pup all lessons in a purchased package
          must be completed in 4 months from purchase date.
        </p>
        
        <div className='Services--container--packages'>

          <Card className='Services--container--card'>
            <h3>1 Lesson</h3>
            <div className='fc'>
              <p className='Services--container--card--text'>Perfect for
                someone who just needs help with one specific behavior. House
                breaking, loose leash walking, and mild separation anxiety are examples.</p>
              <ServiceImage image={data.oneLesson} alt='positive reinforcement' />
            </div>
            <h4 className='Services--container--card--price'>$110</h4>
          </Card>

          <Card className='Services--container--card'>
            <h3>3 Lessons</h3>
            <div className='fc'>
              <p className='Services--container--card--text--packages--single--text'>Great for a new
                dog who needs help with the basics. Obedience work, mild leash reactivity,
                loose leash walking with distractions, and stay.</p>
              <ServiceImage image={data.threeLessons} alt='dog leash walking' />
            </div>
            <h4 className='Services--container--card--price'>$300</h4>
          </Card>

          <Card className='Services--container--card standout'>
            <div className='standout--text'><span>Best Seller</span></div>
            <h3>5 Lessons</h3>
            <div className='fc'>
              <p className='Services--container--card--text'>The 5 lesson
                package is the opportunity to take your dog's training to a
                higher level. We will work through increasing challenging scenarios to
                get the results you want.</p>
              <ServiceImage image={data.fiveLessons} alt='fetch drink trick' />
            </div>
            <div className='Services--container--card--price'>$475</div>
          </Card>

          <Card className='Services--container--card'>
            <h3>Puppy Primer</h3>
            <div className='fc'>
              <div className='Services--container--card--wrapper'>
                <p className='Services--container--card--text'>Getting a
                  new puppy? Then this package is for you.</p>
                <ul>
                  <li><span className='red'>&#9679;</span> House Training</li>
                  <li><span className='red'>&#9679;</span> Nipping and Chewing</li>
                  <li><span className='red'>&#9679;</span> Name Recognition</li>
                  <li><span className='red'>&#9679;</span> Basic Leash Walking</li>
                </ul>
                <p className='note'>For puppies 5 months and under. Package consists of 3 lessons.</p>
              </div>
              <ServiceImage image={data.puppy} alt='puppy training in chicago' />
            </div>
            <div className='Services--container--card--price'>$285</div>
          </Card>

        </div>

        <p className='Services--container--10'>We also offer a package of 10 lessons. <Link to='/Contact' red>Contact us</Link> for pricing.</p>

      </Container>

    </main>
  </Layout>

export default Services

export const query = graphql`
  fragment ServiceImage on File {
    childImageSharp {
      fluid(maxWidth: 480, maxHeight: 640, quality: 80) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }

  query {
    oneLesson: file(relativePath: { eq: "services/dog-training-treat.jpg" }) { ...ServiceImage }
    threeLessons: file(relativePath: { eq: "services/dog-leash-walking.jpg" }) { ...ServiceImage }
    fiveLessons: file(relativePath: { eq: "services/fetch-can-trick.jpg" }) { ...ServiceImage }
    puppy: file(relativePath: { eq: "services/puppy-training-in-chicago.jpg" }) { ...ServiceImage }
  }
`
